import styled from 'styled-components';
import { Row } from '@simplywallst/ui-core';

export const Accordion = styled('section')`
  ${({ theme }) => theme.typography.xSmall}
  border: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.2)};
  &:not(:last-child) {
    border-bottom: none;
  }
  &:nth-child(25) {
    border: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.2)};
  }
  padding: ${({ theme }) => theme.x1spacePx}px 10px;
`;

export const Header = styled(Row)`
  position: relative;
  cursor: pointer;
  padding: ${({ theme }) => theme.x1spacePx}px 10px;
  margin: -${({ theme }) => theme.x1spacePx}px -10px;

  > svg {
    width: ${({ theme }) => theme.x2spacePx}px;
    height: ${({ theme }) => theme.x2spacePx}px;
    fill: ${({ theme }) => theme.color.whiteRGBA(0.3)};
    margin-left: 15px;
  }
  div:nth-child(1) {
    width: 80%;
    padding-right: 5px;
  }
  div:nth-child(2) {
    width: 10%;
    text-align: right;
  }
`;

export const TableContent = styled('table')`
  width: 100%;
  padding-top: ${({ theme }) => theme.x1spacePx}px;
  table-layout: auto;
  border-spacing: 0;
  td {
    vertical-align: top;
    padding: ${({ theme }) => theme.x1spacePx}px 0;
    border-top: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.1)};
    &:nth-child(1) {
      color: ${({ theme }) => theme.color.whiteRGBA(0.5)};
      width: 40%;
    }
  }
`;

interface PercentSharesChanged {
  percentSharesChanged: number;
}

export const ChangeText = styled('span')<PercentSharesChanged>`
  ${({ percentSharesChanged, theme }) => {
    if (percentSharesChanged > 0) {
      return `color: ${theme.color.good}`;
    } else if (percentSharesChanged < 0) {
      return `color: ${theme.color.bad}`;
    }
    return `color: ${theme.color.white}`;
  }}
`;
